import React from 'react';
import { Card, Row, Col, Statistic, Typography, Progress } from 'antd';
import {
  BarChartOutlined,
  ShopOutlined,
  InboxOutlined,
  StockOutlined,
  CheckCircleOutlined,
} from '@ant-design/icons';

const { Title, Paragraph } = Typography;

const SCMAnalytics: React.FC = () => {
  return (
    <div>
      <Title level={2}>
        <BarChartOutlined /> Supply Chain Analytics
      </Title>
      <Paragraph>Supply chain performance metrics and procurement insights.</Paragraph>

      <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="Active Suppliers"
              value={85}
              prefix={<ShopOutlined />}
              valueStyle={{ color: '#145A54' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="Purchase Orders"
              value={234}
              prefix={<InboxOutlined />}
              valueStyle={{ color: '#722ed1' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="Inventory Value"
              value={1250020}
              precision={2}
              prefix="$"
              valueStyle={{ color: '#faad14' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="On-Time Delivery"
              value={92.5}
              precision={1}
              suffix="%"
              prefix={<CheckCircleOutlined />}
              valueStyle={{ color: '#52c41a' }}
            />
          </Card>
        </Col>
      </Row>

      <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
        <Col xs={24} lg={12}>
          <Card title="Supplier Performance" bordered={false}>
            <div style={{ marginBottom: 16 }}>
              <div style={{ marginBottom: 8 }}>
                <span>On-Time Delivery</span>
                <Progress percent={92.5} status="active" strokeColor="#52c41a" />
              </div>
              <div style={{ marginBottom: 8 }}>
                <span>Quality Acceptance Rate</span>
                <Progress percent={95.2} status="active" strokeColor="#145A54" />
              </div>
              <div style={{ marginBottom: 8 }}>
                <span>Lead Time Compliance</span>
                <Progress percent={88.7} status="active" strokeColor="#faad14" />
              </div>
            </div>
          </Card>
        </Col>
        <Col xs={24} lg={12}>
          <Card title="Inventory Turnover" bordered={false}>
            <Paragraph>Inventory turnover analysis would appear here.</Paragraph>
          </Card>
        </Col>
      </Row>

      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24}>
          <Card title="Procurement Spend Analysis" bordered={false}>
            <Paragraph>Procurement spending breakdown by category would appear here.</Paragraph>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default SCMAnalytics;
